/**
 * Created by mac on 9/25/20
 */

const AdministratorScene = cc.Scene.extend({
    ctor: function () {
        this._super();

        this.sceneComponent = ComponentMap.attach(this, new SceneComponent({
            styling: {
                scale9: bundles.admin.frames.background
            },
            bundles: this.listBundles(),
            sceneName: cleverapps.Environment.SCENE_ADMINISTRATOR,
            // no music while editing levels — the same silent disk the prefab editor runs with
            audioStyles: { res: undefined }
        }));
    },

    onSceneLoaded: function () {
        this.mode = AdministratorScene.MODES.HORIZONTAL;

        this.nodes = {};

        this.nodes.adminEpisodes = new AdminEpisodesView(cleverapps.administrator.adminEpisodes);
        this.nodes.adminLevels = new AdminLevelsView(cleverapps.administrator.adminLevels);

        const margin = cleverapps.styles.AdministratorScene.margin;

        const winSize = cleverapps.resolution.getSceneSize();
        const width = winSize.width - this.nodes.adminEpisodes.width - this.nodes.adminLevels.width;
        this.nodes.adminDetails = new AdminDetailsView(cleverapps.administrator.adminDetails, {
            width: width - margin * 2
        });

        this.createGlobalButtons();

        const layout = new cleverapps.Layout(Object.values(this.nodes), {
            direction: cleverapps.UI.HORIZONTAL,
            margin
        });

        layout.setAnchorPoint(0, 1);
        layout.setAlignment(0, this.height);
        this.addChild(layout);

        this.calcMode();

        if (cleverapps.git) {
            cleverapps.git.changeFolders(GitManager.FOLDERS.LEVELS);

            // Edits live in the local cache until they are pushed, and on localhost they survive a
            // reload — so a level can come back tagged from a session whose push never reached the
            // repo, looking exactly like a level that is really tagged. Say so on the way in.
            const pending = cleverapps.git.listLocalChanges();
            if (pending.length) {
                cleverapps.notification.create(`${pending.length} local change(s) not pushed yet`);
            }
        }
    },

    onCloseAction: function () {
        cleverapps.config.adminMode = false;
        cleverapps.snapshotBar && cleverapps.snapshotBar.updateAdminButton();
        cleverapps.setUrlHash({
            episode: undefined,
            level: undefined,
            mode: undefined
        });
    },

    calcMode: function () {
        const calculatedMode = AdministratorScene.MODES.HORIZONTAL;

        if (this.mode !== calculatedMode) {
            this.mode = calculatedMode;

            Object.values(this.nodes).forEach(function (node) {
                node.switchMode(this.mode);
            }, this);
        }
    },

    createGlobalButtons: function () {
        if (cleverapps.git) {
            this.nodes.adminDetails.addChild(new GitButtonsView({
                direction: cleverapps.UI.VERTICAL
            }), 1);
        }

        this.createProductsCacheButton();
    },

    createProductsCacheButton: function () {
        if (typeof FB === "undefined" || !FB.api) {
            return;
        }

        const button = new AdminFbProductsButton(new AdminFBProducts());
        button.setAlignment(cleverapps.styles.AdminFbProductsButton);
        this.nodes.adminDetails.addChild(button);
    },

    listBundles: function () {
        let result = ["admin", "game", "tiles", "units_main"];

        if (cleverapps.config.type === "match3") {
            result = result.concat(AdminLevelMiniature.bundles.match3()).concat(AdminLevelMaxiature.bundles.match3());
        }

        return cleverapps.unique(result);
    }
});

cleverapps.styles.AdministratorScene = {
    margin: 50
};

AdministratorScene.getUrlHashData = function () {
    const active = cleverapps.administrator.adminLevels.getActive();
    return {
        episode: active ? active.episodeNo : undefined,
        level: active ? active.levelNo : undefined,
        mode: "admin"
    };
};

AdministratorScene.open = function (f) {
    const actions = [
        AdminEpisodes.ResetAction,

        function (f) {
            cleverapps.setUrlHash(AdministratorScene.getUrlHashData());
            cleverapps.config.adminMode = true;
            cleverapps.snapshotBar && cleverapps.snapshotBar.updateAdminButton();
            connector.ads.closeStickyCallback();
            cleverapps.scenes.replaceScene(new AdministratorScene(), f);
        }
    ];

    if (f) {
        cleverapps.focusManager.compound(f, actions);
    } else if (cleverapps.focusManager.isFocused()) {
        cleverapps.focusManager.distract({
            focus: "administrator",
            actions
        });
    } else {
        cleverapps.focusManager.display({
            focus: "administrator",
            actions
        });
    }
};

AdministratorScene.IsAvailable = function () {
    if (cleverapps.isLocalhost()) {
        return true;
    }

    return Boolean(AdminAccess.userName);
};

(function () {
    const params = cleverapps.getRequestParameters(location.hash);
    if (!params.mode || !cleverapps.config.debugMode) {
        return;
    }

    let locationId = params.location;
    if (cleverapps.isNumber(locationId)) {
        locationId = parseInt(locationId);
    }

    const baseOnStartup = cleverapps.Plot.onStartup;
    cleverapps.Plot.onStartup = function (f, returnClassOnly) {
        if (typeof AdministratorScene !== "undefined" && !AdministratorScene.IsAvailable()) {
            return baseOnStartup.call(cleverapps.Plot, f, returnClassOnly);
        }

        cleverapps.config.adminMode = true;
        cleverapps.snapshotBar && cleverapps.snapshotBar.updateAdminButton();

        if (params.mode === "editor") {
            cleverapps.config.editorMode = true;
            cleverapps.snapshotBar && cleverapps.snapshotBar.updateAdminButton();
        }

        if (params.playLevel) {
            if (returnClassOnly) {
                return cleverapps.meta.getMainScene();
            }

            cleverapps.focusManager.compound(f, [
                AdminEpisodes.ResetAction,

                function (f) {
                    LevelManager.getInstance().playLevel(f);
                }
            ]);
        } else if (params.mode === "admin") {
            if (returnClassOnly) {
                return AdministratorScene;
            }

            AdministratorScene.open(f);
        } else if (params.mode === "editor") {
            if (returnClassOnly) {
                return EditorScene;
            }

            cleverapps.focusManager.compound(f, [
                AdminEpisodes.ResetAction,

                function (f) {
                    LevelManager.getInstance().editLevel(f);
                }
            ]);
        } else if (params.mode === "admin_locations") {
            if (returnClassOnly) {
                return AdminLocationsScene;
            }
            AdminLocationsScene.open(f);
        } else if (params.mode === "editor_location") {
            if (returnClassOnly) {
                return {
                    scene: EditorLocationScene,
                    options: [locationId]
                };
            }
            EditorLocationScene.open(f);
        } else if (params.mode === "play_location") {
            if (returnClassOnly) {
                return cleverapps.meta.getMainScene(locationId);
            }

            cleverapps.meta.switchLocation(locationId);
            cleverapps.meta.gotoLocationScene(f);
        }
    };
}());

AdministratorScene.MODES = {
    HORIZONTAL: 0,
    VERTICAL: 1
};

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    ADMIN_TEXT_COLOR: new cc.Color(89, 144, 221, 255)
});
